export const draggedElementId = 'drag-element-icon';
